import { Extension } from '@tiptap/core';
const SingleLine = Extension.create({
    addKeyboardShortcuts () {
        return {
            Enter: ()=>true,
            'Shift-Enter': ()=>true,
            'Mod-Enter': ()=>true
        };
    }
});
export { SingleLine };

//# sourceMappingURL=singleline.js.map